angular
  .module('company')

  .directive('headquarterInfoPreview', function() {
    return {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        headquarter: '=ngModel'
      },
      templateUrl: 'custom/company/views/partials/headquarterInfoPreview.html'
    };
  });
